<rc-content-with-action>
  <div slot="content">
    <rc-stock-menu></rc-stock-menu>
  </div>
</rc-content-with-action>
